import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { FirebaseProvider } from '../firebase/firebase';
import { GlobalVars } from '../../app/app.environment';
import { Coefficient } from '../../models/coefficient';
import { tableNames } from '../../app/app.constants';
import { QueryModel } from '../../models/query';


@Injectable()
export class CoefficientProvider {

  constructor(
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
  ) {}

  getAll(): Observable<Coefficient[]> {
    return this.firebaseService.list(this.getBaseRoot());
  }

  getAllOnce(): Observable<Coefficient[]> {
    return this.firebaseService.listOnce(this.getBaseRoot());
  }

  getSpecific(areaId: string): Observable<Coefficient[]> {
    let query = new QueryModel();
    
    query.orderByChild = 'area';
    query.equalTo = areaId;

    return this.firebaseService.list(this.getBaseRoot(), query);
  }

  getSpecificOnce(areaId: string): Observable<Coefficient[]> {
    let query = new QueryModel();
    
    query.orderByChild = 'area';
    query.equalTo = areaId;

    return this.firebaseService.listOnce(this.getBaseRoot(), query);
  }

  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/' + tableNames.Coefficients + '/';
  }
}



// WEBPACK FOOTER //
// ./src/providers/coefficient/coefficient.ts